import {Link, useLocation} from "react-router-dom";
import {useState} from "react";


function Header() {
    const location = useLocation();
    const [isOpen, setIsopen] = useState(false);

    const ToggleSidebar = () => {
        isOpen === true ? setIsopen(false) : setIsopen(true);
    }

    return (
        <>
            <header className={location.pathname === '/' ? 'absolute' : ''}>
                <div className="container">
                    <nav>
                        <Link to="/" className="logo">
                            <img src={process.env.PUBLIC_URL + "/images/logo.webp"} alt=""/>
                        </Link>
                        <button className="menuBtn" onClick={ToggleSidebar}>
                            <i className="fas fa-bars"/>
                        </button>
                        <div className={`overlay ${isOpen === true ? 'active' : ''}`}/>
                        <div className={`navContent ${isOpen === true ? 'active' : ''}`}>
                            <ul>
                                <li className='dropdown'>
                                    <Link>
                                        About Us
                                    </Link>
                                    <ul className='dropdownMenu'>
                                        <li>
                                            <Link onClick={ToggleSidebar} to='/about'>
                                                About Us
                                            </Link>
                                        </li>
                                        <li>
                                            <Link onClick={ToggleSidebar} to='/blog'>
                                                Blog
                                            </Link>
                                        </li>
                                        <li>
                                            <Link onClick={ToggleSidebar} to='/our-service'>
                                                Our Service
                                            </Link>
                                        </li>
                                        <li>
                                            <Link onClick={ToggleSidebar} to='/contact'>
                                                Contact
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <Link onClick={ToggleSidebar} to="/programs">
                                        Programs
                                    </Link>
                                </li>
                                <li className='dropdown'>
                                    <Link onClick={ToggleSidebar}>
                                        Classes
                                    </Link>
                                    <ul className="dropdownMenu">
                                        <li>
                                            <Link onClick={ToggleSidebar} to='/remote'>
                                                Remote
                                            </Link>
                                        </li>
                                        <li>

                                            <Link onClick={ToggleSidebar} to="/on-site">
                                                On-site
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className='dropdown'>
                                    <Link onClick={ToggleSidebar}>
                                        Corporate
                                    </Link>
                                    <ul className="dropdownMenu">
                                        <li>
                                            <Link onClick={ToggleSidebar} to="/hire-grad">
                                                Hire our grads
                                            </Link>
                                        </li>
                                        <li>
                                            <Link onClick={ToggleSidebar} to='/workforce'>
                                                Workforce Training
                                            </Link>
                                        </li>
                                        <li>
                                            {/*<Link onClick={ToggleSidebar} to="/consulting">*/}
                                            {/*    Consulting Service*/}
                                            {/*</Link>*/}
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <Link onClick={ToggleSidebar} to="/apply-now" className="themeBtn">
                                        Apply Now
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </header>
        </>
    )
}

export default Header